import { render, staticRenderFns } from "./LimitedTimeTaskListItem.vue?vue&type=template&id=237907b2&scoped=true&"
import script from "./LimitedTimeTaskListItem.vue?vue&type=script&lang=js&"
export * from "./LimitedTimeTaskListItem.vue?vue&type=script&lang=js&"
import style0 from "./LimitedTimeTaskListItem.vue?vue&type=style&index=0&id=237907b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237907b2",
  null
  
)

export default component.exports